/* That Girl HQ theme interactions — safe to run on any page; every feature
   checks for its elements first. Re-runs when the theme editor reloads a section. */
(function () {
  function initReveal(root) {
    var els = root.querySelectorAll('.tg-reveal:not(.in)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.boundingClientRect.bottom < 0) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initMarquee(root) {
    root.querySelectorAll('.tg-marquee .track:not([data-dup])').forEach(function (track) {
      track.setAttribute('data-dup', '1');
      track.innerHTML += track.innerHTML;
    });
  }

  function initTour(root) {
    root.querySelectorAll('.tg-tour:not([data-init])').forEach(function (tour) {
      tour.setAttribute('data-init', '1');
      var stage = tour.querySelector('.tg-duo-stage');
      var img1 = tour.querySelector('.screen.s1');
      var img2 = tour.querySelector('.screen.s2');
      var tabs = Array.prototype.slice.call(tour.querySelectorAll('.tg-tour-tab'));
      if (!stage || !img1 || !img2 || !tabs.length) return;
      var userTook = false, idx = 0;

      tabs.forEach(function (t) {
        var a = new Image(); a.src = t.getAttribute('data-screen');
        var b = new Image(); b.src = t.getAttribute('data-screen2');
      });

      function activate(i) {
        idx = i;
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.classList.toggle('active', on);
          if (on) {
            var bar = t.querySelector('.tg-tour-bar i');
            if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
          }
        });
        stage.classList.add('switching');
        stage.classList.toggle('alt');
        setTimeout(function () {
          img1.src = tabs[i].getAttribute('data-screen');
          img2.src = tabs[i].getAttribute('data-screen2');
          stage.classList.remove('switching');
        }, 300);
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { userTook = true; activate(i); });
      });
      setInterval(function () { if (!userTook) activate((idx + 1) % tabs.length); }, 5000);
    });
  }

  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.9-10-9.5C.6 8.6 2.3 5 5.7 5c2 0 3.4 1.2 4.3 2.6C10.9 6.2 12.3 5 14.3 5c3.4 0 5.1 3.6 3.7 6.5C15.5 16.1 12 21 12 21z"/></svg>';
  function initCheer(root) {
    root.querySelectorAll('.tg-cheer-btn:not([data-init])').forEach(function (btn) {
      btn.setAttribute('data-init', '1');
      var count = btn.querySelector('.count');
      btn.addEventListener('click', function () {
        if (count) count.textContent = +count.textContent + 1;
        for (var i = 0; i < 5; i++) {
          var b = document.createElement('span');
          b.className = 'tg-burst';
          b.innerHTML = HEART;
          b.style.setProperty('--dx', (Math.random() * 70 - 35) + 'px');
          b.style.left = (18 + Math.random() * 60) + 'px';
          b.style.top = '-4px';
          btn.appendChild(b);
          setTimeout(function (el) { el.remove(); }.bind(null, b), 1000);
        }
      });
    });
  }

  function initCounters(root) {
    var els = root.querySelectorAll('.tg-count:not([data-init])');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, target = +el.getAttribute('data-target') || 0, dur = 1500, t0 = performance.now();
        (function tick(t) {
          var p = Math.min((t - t0) / dur, 1), ease = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * ease).toLocaleString();
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { el.setAttribute('data-init', '1'); io.observe(el); });
  }

  function initAll(root) {
    initReveal(root); initMarquee(root); initTour(root); initCheer(root); initCounters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
